"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_beautiful_dnd_1 = require("react-beautiful-dnd");
const material_1 = require("@mui/material");
const order_item_1 = require("../order-item");
const styled_1 = require("./styled");
const InnerListItem = (0, react_1.memo)(props => {
    const { order, index, onEdit } = props;
    return ((0, jsx_runtime_1.jsx)(react_beautiful_dnd_1.Draggable, { draggableId: order.id.toString(), index: index, children: ((provider, snapshot) => ((0, jsx_runtime_1.jsx)(order_item_1.OrderListItem, { order: order, isDragging: snapshot.isDragging, isGroupedOver: Boolean(snapshot.combineTargetFor), provided: provider, onEdit: onEdit }))) }));
});
const OrderList = props => {
    const { listId = "LIST", items = [], onEdit } = props;
    return ((0, jsx_runtime_1.jsx)(react_beautiful_dnd_1.Droppable, { droppableId: listId, children: ((provider) => ((0, jsx_runtime_1.jsx)(styled_1.Wrapper, { ...provider.droppableProps, children: (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { height: "100%" }, ref: provider.innerRef.bind(provider), children: [items.map((order, i) => ((0, jsx_runtime_1.jsx)(InnerListItem, { order: order, index: i, onEdit: onEdit }, order.id))), provider.placeholder] }) }))) }));
};
exports.OrderList = OrderList;
//# sourceMappingURL=index.js.map